import useSWR from "swr";
import fetcher from "@adora/shared/utils/fetch";
import { RelativeUrl } from "@adora/shared/utils/environment";
import { User, UserAccountType, UserServerResponse } from "../types/user";
import { Role } from "@adora/shared/types/auth";

export const UsersUrl = "users";

export const transformUser = (user: UserServerResponse[]): User[] => {
  return user.map<User>((u) => ({
    id: u.id,
    name: u.name,
    brandId: u.brand_id,
    accountType: u.account_type,
    role: u.role,
    brands: u.brands,
    externalInfo: u.external_info,
    email: u.email,
    rmnPublisherId: u.rmn_publisher_id
  }));
};

export interface UseUsersProps {
  accountType?: UserAccountType;
  role?: Role;
  brandId?: string;
}

const useUsers = ({ accountType, role, brandId }: UseUsersProps = {}) => {
  const params = new URLSearchParams();
  if (accountType) {
    params.append("account_type", accountType);
  }
  if (role) {
    params.append("role_name", role);
  }
  if (brandId) {
    params.append("brand_id", brandId);
  }

  const queryString = params.toString();
  const url = `${RelativeUrl}/${UsersUrl}${queryString && `?${queryString}`}`;

  const { data, error, isLoading } = useSWR(url, (url: string) => fetcher<UserServerResponse[]>(url));

  return {
    users: data ? transformUser(data) : undefined,
    error,
    isLoading
  };
};

export default useUsers;
